module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAxIiBoZWlnaHQ9IjE4MSIgdmlld0JveD0iMCAwIDMwMSAxODEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjMDA5RTQ5IiBkPSJNLjUuNWgzMDB2MTgwSC41eiIvPjxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0uNS41bDMwMCA5MC0zMDAgOTB6Ii8+PHBhdGggZmlsbD0iI0ZDRDExNiIgZD0iTS41IDguMzNMMjc0LjEgOTAuNS41IDE3Mi42N3oiLz48cGF0aCBmaWxsPSIjMDAwIiBkPSJNLjUuNWwxNTAgOTAtMTUwIDkweiIvPjxwYXRoIGZpbGw9IiNDRTExMjYiIGQ9Ik0uNSAxMWwxMzIuNTEgNzkuNUwuNSAxNzB6Ii8+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-gy.svg
// module id = Skly
// module chunks = 2